import React from 'react';
import {Button, Col, Label, Row} from 'reactstrap';
import {AvForm, AvGroup} from 'availity-reactstrap-validation';
import Translate from "../../shared/language/Translate";
import FormSection from "../../shared/component/form/FormSection";
import WebMenuService from "../../shared/service/WebMenuService";
import GeneralUtils from "../../shared/utils/GeneralUtils";
import {Card} from "primereact/card";
import {BreadCrumb} from "primereact/breadcrumb";
import ModalConfirm from "../../shared/component/dialog/ModalConfirm";
import {RadioButton} from "primereact/radiobutton";
import AvField from "../../shared/component/form/AvField";
import {AutoComplete} from "primereact/autocomplete";
import ProductService from "../../shared/service/ProductService";
import ProductGroupService from "../../shared/service/ProductGroupService";
import {toast} from "react-toastify";
import {MENU_DISPLAY_TYPE, WEB_IMAGE_SERVER_URL, WEB_MENU_SMALL_IMAGE, WEB_MENU_HOURS, WEB_MENU_MINUTES} from "../../shared/utils/Constants";
import RestTableService from "../../shared/service/RestTableService";
import LocationService from "../../shared/service/LocationService";
import {MultiSelect} from "primereact/multiselect";
import {FileUpload} from "primereact/fileupload";
import {Button as ButtonSearch} from "primereact/components/button/Button";
import '../../shared/styles/SettingsPage.css';

const defaultWebMenu = {
    id: '',
    parentId: '',
    productId: '',
    longname: '',
    name: '',
    status: 'ACTIVE',
    fileType: '',
    fileName: 'Choose',
    fileTypeTill: '',
    fileNameTill: 'Choose',
    grpContent: null,
    grpContentX: null,
    hasSubMenu: false,
    subTitle: null,
    productTags: [],
    grpMain: null,
    grpOption1: null,
    grpOption2: null,
    grpOption3: null,
    grpOption4: null,
    grpOption1Label: 'opt1',
    grpOption2Label: 'opt2',
    grpOption3Label: 'opt3',
    grpOption4Label: 'opt4',
    kitchenPrinter1: '',
    kitchenPrinter2: '',
    kitchenPrinter3: '',
    kitchenPrinter4: '',
    fontSize: '3.0vmin',
    fontWeight: 'bold',
    textAlign: 'center',
    flex: 1,
    menuStyleHeightFlex: 1,
    rowNo: 1,
    colNo: 1,
    borderRadius: '1vmin',
    pageSize: 1,
    rowSize: 1,
    spaceLength: null,
    pinned: false,
    lining: false,
    dummy: false,
    displaySiblings: false,
    displayGrandChilds: false,
    tillIdList: '',
    showInline: false,
    singleLine: false,
    condiment: false,
    printOrder: 0,
    webEnabled: true,
    startHour: null,
    startMinute: null,
    endHour: null,
    endMinute: null,
    locationBssIdList: ''


};

export default class WebMenuList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            webMenu: defaultWebMenu,
            webMenuList: [],
            crumbItems: [],
            selectValue: 'Barcode',
            mainGroupList: [],
            productList: [],
            searchHasImage: null,
            barcode: '',
            searchBarcode: '',
            selectedProduct: null,
            productId: null,
            webMenuId: null,
            offset: 0,
            limit: 40,
            allDataLoaded: false,
            filterOption: "all",
            locationList: [],
        }
        this.webMenuService = new WebMenuService();
        this.productService = new ProductService();
        this.restTableService = new RestTableService();
        this.productGroupService = new ProductGroupService();
        this.locationService = new LocationService();
        this.uploadRefs = {};
    }

    async componentDidMount() {
        window.addEventListener('scroll', this.handleScroll);
        let id = window.location.href.split('?')[1];
        if (!GeneralUtils.isNullOrEmpty(id)) {
            const str = sessionStorage.getItem('crumbItems');
            if (!GeneralUtils.isNullOrEmpty(str)) {
                const parsedArray = JSON.parse(str);
                var crumbItems = [];
                for (let data of parsedArray) {
                    crumbItems.push({
                        label: data.label, id: data.id, order: data.order, command: (e) => {
                            this.refreshCrumbItems(data)
                            this.loadInitialWebMenus(data.id);

                        }
                    })
                }
                await this.setState({
                    crumbItems: crumbItems,
                });
            } else {
                await this.setState({
                    crumbItems: [],
                });
            }
            this.refresh();
        } else {
            this.refresh();
        }

    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    }

    handleScroll = () => {
        if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight - 200 &&
            !this.state.loading &&
            !this.state.allDataLoaded) {
            const parentId = this.getParentId(); // parentId'yi al
            this.loadMoreWebMenus(parentId);     // doğru şekilde çağır
        }
    };


    refresh() {
        this.setState({
            barcode: '',
            selectedProduct: null,
            selectValue: 'Barcode',
            productId: null,
            webMenuId: null,
            searchHasImage: null,
            searchBarcode: null,
            offset: 0,
            allDataLoaded: false,
            loading: false,

        });

        let parentId = this.getParentId();
        if (GeneralUtils.isNullOrEmpty(parentId)) {
            this.webMenuService.findParents().then(response => this.setState({
                webMenuList: response,
            }));
        } else {
            this.webMenuService.findSubMenusByParentId(parentId).then(response => this.setState({
                webMenuList: response,
            }));
        }

        this.locationService.findAll().then(response => this.setState({locationList: response || []}));

        this.productGroupService.findAll().then(response => this.setState({mainGroupList: response}));


    }

    render() {
        return (
            <div className="settings-page settings-page--full col-md-12">
                <AvForm>
                    <div className="settings-page__shell">
                        {this.webMenuList()}
                    </div>
                </AvForm>
            </div>
        );
    }

    renderFilter() {
        return (
            <div className="settings-page__section settings-page__web-menu-list-section">
                <h2 className="settings-page__section-title">Search Web Menu</h2>
                <div className="settings-page__filter settings-page__filter--form">
                    <div className="settings-page__radio-row">
                        <div style={{display: 'inline-flex', alignItems: 'center', gap: '4px'}}>
                            <RadioButton
                                inputId="all"
                                name="filter"
                                value="all"
                                onChange={this.handleFilterChange}
                                checked={this.state.filterOption === "all"}
                            />
                            <label htmlFor="all">All</label>
                        </div>

                        <div style={{display: 'inline-flex', alignItems: 'center', gap: '4px'}}>
                            <RadioButton
                                inputId="hasImage"
                                name="filter"
                                value="hasImage"
                                onChange={this.handleFilterChange}
                                checked={this.state.filterOption === "hasImage"}
                            />
                            <label htmlFor="priceUnmatched">Has Image</label>
                        </div>

                        <div style={{display: 'inline-flex', alignItems: 'center', gap: '4px'}}>
                            <RadioButton
                                inputId="noImage"
                                name="filter"
                                value="noImage"
                                onChange={this.handleFilterChange}
                                checked={this.state.filterOption === "noImage"}
                            />
                            <label htmlFor="priceUnmatched">No Image</label>
                        </div>

                        <div style={{display: 'inline-flex', alignItems: 'center', gap: '4px'}}>
                            <RadioButton
                                inputId="barcode"
                                name="filter"
                                value="barcode"
                                onChange={this.handleFilterChange}
                                checked={this.state.filterOption === "barcode"}
                            />
                            <label htmlFor="productUnmatched">Barcode</label>
                        </div>
                        {this.state.filterOption === "barcode" && (
                            <div className="settings-page__filter-field settings-page__filter-field--barcode">
                                <AvGroup>
                                    <AvField
                                        type="number"
                                        name="searchBarcode"
                                        className="form-control"
                                        disabled={false}
                                        max="99999999999999"
                                        value={this.state.searchBarcode}
                                        onChange={this.__handleChangeSearchBarcode}/>
                                </AvGroup>
                            </div>
                        )}
                    </div>





                </div>
            </div>
        );
    }

    renderSelectItems() {

        return (
            <div className="settings-page__section settings-page__web-menu-list-section">
            <ModalConfirm header='Warning' ok='OK' onOkClick={this.delete}
                          onCancelClick={() => this.setState({displayShowStatusConfirmDialog: false})}
                          show={this.state.displayShowStatusConfirmDialog}
                          message={this.state.noticeResponse}/>

            <h2 className="settings-page__section-title">Select Product</h2>
            <div className="settings-page__filter settings-page__filter--form">
                <div className="settings-page__radio-row">
                    <div className="settings-page__radio-item">
                        <RadioButton inputId="ingredient1" value="Barcode" onChange={(e) => {
                            this.setState({
                                selectValue: e.value,
                            });
                        }} checked={this.state.selectValue === 'Barcode'}/>
                        <label htmlFor="ingredient1">Barcode</label>
                    </div>
                    <div className="settings-page__radio-item">
                        <RadioButton inputId="ingredient2" value="Name" onChange={(e) => {
                            this.setState({
                                selectValue: e.value,
                            });
                        }} checked={this.state.selectValue === 'Name'}/>
                        <label htmlFor="ingredient2">Name</label>
                    </div>
                    <div className="settings-page__radio-item">
                        <RadioButton inputId="ingredient3" value="Product Group" onChange={(e) => {
                            this.setState({
                                selectValue: e.value,
                            });
                        }} checked={this.state.selectValue === 'Product Group'}/>
                        <label htmlFor="ingredient3">Product Group</label>
                    </div>
                </div>

                {this.state.selectValue === "Barcode" && (
                    <div className="settings-page__filter-row settings-page__filter-row--cols-2 settings-page__form-fields">
                        <div className="settings-page__filter-field">
                            <AvGroup>
                                <Label for="tradingName">
                                    <Translate contentKey="productGroup.tradingName">Barcode</Translate>
                                </Label>
                                <AvField
                                    type="number"
                                    name="barcode"
                                    className="form-control"
                                    disabled={false}
                                    max="99999999999999"
                                    onKeyDown={this._handleKeyDown}
                                    value={this.state.barcode}
                                    onChange={this.__handleChangeBarcode}/>
                            </AvGroup>
                        </div>
                    </div>
                )}

                {this.state.selectValue === "Name" && (
                    <div className="settings-page__filter-row settings-page__filter-row--cols-2 settings-page__form-fields">
                        <div className="settings-page__filter-field">
                            <AvGroup>
                                <Label for="tradingName">
                                    <Translate contentKey="productGroup.tradingName">Name</Translate>
                                </Label>
                                <AutoComplete value={this.state.selectedProduct}
                                              suggestions={this.state.filteredProducts}
                                              completeMethod={this.searchProduct}
                                              field="longname"
                                              disabled={false}
                                              onChange={(e) => {
                                                  let value = e.target.parsedValue !== undefined ? e.target.parsedValue : e.target.value;
                                                  this.setState({selectedProduct: value});
                                                  if (!GeneralUtils.isNullOrEmpty(e.value.id)) {
                                                      this.webMenuService.addItemToWebMenu(this.getParentId(), e.value.id, -1).then((response) => {
                                                          if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                                                              this.refresh();
                                                          }
                                                      });
                                                  }
                                              }}
                                />
                            </AvGroup>
                        </div>
                    </div>
                )}

                {this.state.selectValue === "Product Group" && (
                    <div className="settings-page__filter-row settings-page__filter-row--cols-2 settings-page__form-fields">
                        <div className="settings-page__filter-field">
                            <AvGroup>
                                <Label for="tradingName">
                                    <Translate contentKey="productGroup.tradingName">Main Group</Translate>
                                </Label>
                                <AvField type="select" className="form-control" name="grpMain"
                                         disabled={false}
                                         value={this.state.webMenu.grpMain}
                                         onChange={this.__handleChangeMainGroup}>
                                    <option value='' key=''/>
                                    {this.state.mainGroupList.map(element => (
                                        <option value={element.id} key={element.id}>
                                            {element.name}
                                        </option>))}
                                </AvField>
                            </AvGroup>
                        </div>
                        <div className="settings-page__filter-field">
                            <AvGroup>
                                <Label for="cityId">
                                    <Translate contentKey="location.cityId">Product</Translate>
                                </Label>
                                <AvField type="select" className="form-control" name="productId"
                                         disabled={false}
                                         value={this.state.webMenu.productId}
                                         onChange={this.__handleChangeProduct}>
                                    <option value='' key=''/>
                                    {this.state.productList.map(element => (
                                        <option value={element.id} key={element.id}>
                                            {element.longname}
                                        </option>))}
                                </AvField>
                            </AvGroup>
                        </div>
                    </div>
                )}
            </div>
        </div>)
    };

    renderItems() {

        let form = [];


        form.push(this.renderCrumbs());
        form.push(this.state.crumbItems.length > 0 && this.renderFilter())
        form.push(this.state.crumbItems.length > 0 && this.renderSelectItems())
        form.push(
            <div className="settings-page__web-menu-cards">
                {this.renderCards()}
            </div>
        );

        return form;
    }

    renderCrumbs() {
        const home = {
            icon: 'pi pi-home', id: -1, command: (e) => {
                this.webMenuService.findParents().then(response => this.setState({
                    webMenuList: response,
                    originalWebMenuList: response,
                    offset: 0,
                    filterOption: "all",
                    allDataLoaded: false,
                    loading: false
                }));
                this.setState({
                    crumbItems: []
                });

            }
        }


        if (this.state.crumbItems.length > 0)
            return (
                <div className="settings-page__web-menu-breadcrumb">
                    <BreadCrumb model={this.state.crumbItems} home={home}/>
                </div>
            );
    }

    refreshCrumbItems(itemSub) {
        let crumbItems = this.state.crumbItems;
        const objWithIdIndex = crumbItems.findIndex((obj) => obj.order === itemSub.order);
        if (objWithIdIndex > -1) {
            crumbItems.length = objWithIdIndex + 1;
        }
        this.setState({crumbItems: crumbItems});
    }

    renderAddNewIconHandler(e, item) {
        this.onItemClick(item);
        e.stopPropagation();
    }

    renderEditIconHandler(e, item) {
        const jsonArray = JSON.stringify(this.state.crumbItems);
        sessionStorage.setItem("crumbItems", jsonArray);
        window.location.href = "#webMenuSave?" + item.id;
        e.stopPropagation();
    }

    renderEditIcon(item) {
        if (GeneralUtils.checkPrivilege("post_product/webmenu")) {
            return <Button color="outline-primary" className="settings-page__btn--edit"
                           onClick={(e) => this.renderEditIconHandler(e, item)}>
                <Translate contentKey="entity.action.cancel">Details</Translate>
            </Button>
        }

    }

    renderAddNewIcon(item) {
        if (GeneralUtils.checkPrivilege("post_product/webmenu") && item.hasSubMenu) {
            return <Button color="outline-primary" className="settings-page__btn--edit"
                           onClick={(e) => this.renderAddNewIconHandler(e, item)}>
                <Translate contentKey="entity.action.cancel">SubMenu</Translate>
            </Button>
        }

    }

    renderName(itemSub) {
        return (
            <AvGroup>

                <AvField
                    type="text"
                    className="form-control"
                    name="name"
                    disabled={false}
                    validate={{
                        maxLength: {
                            value: 255,
                            errorMessage: "You can enter up to 255 characters in this field."
                        }
                    }}
                    value={itemSub.name}
                    onChange={(e) => this.__handleChange(e, itemSub)}/>

            </AvGroup>


        )
    }

    renderMenuSorting(itemSub) {
        if (itemSub.menuDisplayTypeParent != "e.menuDisplayNo, e.name") {
            return;
        } else {
            return (


                <AvGroup>
                    <Label for="firstName">
                        <Translate contentKey="productfirstName">Menu Sorting</Translate>
                    </Label>


                    <AvField
                        type="select"
                        className="form-control"
                        name="menuDisplayTypeParent"
                        disabled={true}
                        value={itemSub.menuDisplayTypeParent}
                        onChange={(e) => this.__handleChange(e, itemSub)}>
                        {MENU_DISPLAY_TYPE.map(element => (
                            <option value={element.value} key={element.value}>
                                {element.name}
                            </option>))}
                    </AvField>


                </AvGroup>


            )
        }

    }

    renderMenuSortingNo(itemSub) {
        if (itemSub.menuDisplayTypeParent == "e.menuDisplayNo, e.name")
            return (


                <AvGroup>
                    <Label for="firstName">
                        <Translate contentKey="productfirstName">Menu Sorting No</Translate>
                    </Label>

                    <AvField
                        name="menuDisplayNo"
                        type="number"
                        disabled={false}
                        value={itemSub.menuDisplayNo}
                        onChange={(e) => this.__handleChange(e, itemSub)}
                        className="table-responsive"

                    />


                </AvGroup>
            )
    }


    renderImage(itemSub) {
        return (
            <AvGroup>
                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '6px',
                    minHeight: '34px'
                }}>
                    <FileUpload
                        name="demo"
                        accept="image/*"
                        maxFileSize={50000}
                        onValidationFailError={GeneralUtils.onValidationFailErrorFile}
                        invalidFileSizeMessageDetail="Maximum upload size is 50K."
                        chooseLabel={itemSub.fileName == null ? "Choose" : itemSub.fileName}
                        disabled={false}
                        ref={elem => this.uploadRefs[itemSub.id] = elem}
                        mode="basic"
                    />

                    <ButtonSearch
                        icon="pi pi-minus"
                        disabled={false}
                        onClick={() => this.removeDocument(itemSub.id, WEB_MENU_SMALL_IMAGE)}
                        style={{ flexShrink: 0 }}
                    />

                    <img
                        onError={(e) => e.target.src = "assets/layout/images/white.png"}
                        src={
                            !GeneralUtils.isNullOrEmpty(itemSub.webImagePath)
                                ? WEB_IMAGE_SERVER_URL + itemSub.webImagePath
                                : "assets/layout/images/white.png"
                        }
                        style={{
                            width: '30px',
                            height: '30px',
                            minWidth: '30px',
                            minHeight: '30px',
                            objectFit: 'contain',
                            marginLeft: '6px',
                            flexShrink: 0
                        }}
                    />
                </div>
            </AvGroup>
        );
    }

    renderSubMenuSorting(itemSub) {
        if (itemSub.hasSubMenu)
            return (


                <AvGroup>
                    <Label for="firstName">
                        <Translate contentKey="productfirstName">SubMenu Sorting</Translate>
                    </Label>


                    <AvField
                        type="select"
                        className="form-control"
                        name="menuDisplayType"
                        disabled={false}
                        value={itemSub.menuDisplayType}
                        onChange={(e) => this.__handleChange(e, itemSub)}>
                        {MENU_DISPLAY_TYPE.map(element => (
                            <option value={element.value} key={element.value}>
                                {element.name}
                            </option>))}
                    </AvField>


                </AvGroup>


            )
    }

    renderScheduleFields(itemSub) {
        if (!GeneralUtils.isNullOrEmpty(this.getParentId())) {
            return null;
        }
        const formatHour = (hour) => hour != null && hour !== '' ? String(hour) : '';
        const formatMinute = (minute) => minute != null && minute !== '' ? String(minute) : '';
        return (
            <>
                <Col md={3}>
                    <AvGroup>
                        <Label>Start Hour</Label>
                        <AvField
                            type="select"
                            className="form-control"
                            name="startHour"
                            disabled={false}
                            value={formatHour(itemSub.startHour)}
                            onChange={(e) => this.__handleChange(e, itemSub)}>
                            <option value="" key=""/>
                            {WEB_MENU_HOURS.map(element => (
                                <option value={element.value} key={element.value}>
                                    {element.name}
                                </option>))}
                        </AvField>
                    </AvGroup>
                </Col>
                <Col md={3}>
                    <AvGroup>
                        <Label>Start Minute</Label>
                        <AvField
                            type="select"
                            className="form-control"
                            name="startMinute"
                            disabled={false}
                            value={formatMinute(itemSub.startMinute)}
                            onChange={(e) => this.__handleChange(e, itemSub)}>
                            <option value="" key=""/>
                            {WEB_MENU_MINUTES.map(element => (
                                <option value={element.value} key={element.value}>
                                    {element.name}
                                </option>))}
                        </AvField>
                    </AvGroup>
                </Col>
                <Col md={3}>
                    <AvGroup>
                        <Label>End Hour</Label>
                        <AvField
                            type="select"
                            className="form-control"
                            name="endHour"
                            disabled={false}
                            value={formatHour(itemSub.endHour)}
                            onChange={(e) => this.__handleChange(e, itemSub)}>
                            <option value="" key=""/>
                            {WEB_MENU_HOURS.map(element => (
                                <option value={element.value} key={element.value}>
                                    {element.name}
                                </option>))}
                        </AvField>
                    </AvGroup>
                </Col>
                <Col md={3}>
                    <AvGroup>
                        <Label>End Minute</Label>
                        <AvField
                            type="select"
                            className="form-control"
                            name="endMinute"
                            disabled={false}
                            value={formatMinute(itemSub.endMinute)}
                            onChange={(e) => this.__handleChange(e, itemSub)}>
                            <option value="" key=""/>
                            {WEB_MENU_MINUTES.map(element => (
                                <option value={element.value} key={element.value}>
                                    {element.name}
                                </option>))}
                        </AvField>
                    </AvGroup>
                </Col>
            </>
        );
    }

    parseLocationBssIdList = (locationBssIdList) => {
        if (GeneralUtils.isNullOrEmpty(locationBssIdList)) {
            return [];
        }
        return locationBssIdList.split(',').map(item => item.trim()).filter(item => item);
    }

    renderLocationFields(itemSub) {
        if (!GeneralUtils.isNullOrEmpty(this.getParentId())) {
            return null;
        }
        return (
            <Col md={12}>
                <AvGroup>
                    <Label>Locations</Label>
                    <MultiSelect
                        display="chip"
                        appendTo={typeof document !== 'undefined' ? document.body : null}
                        className="settings-page__web-menu-location-multiselect"
                        value={this.parseLocationBssIdList(itemSub.locationBssIdList)}
                        options={this.state.locationList}
                        name="locationBssIdList"
                        disabled={false}
                        onChange={(e) => this.__handleLocationChange(e, itemSub)}
                        optionLabel="name"
                        optionValue="bssId"
                        placeholder="Select locations"
                        maxSelectedLabels={4}/>
                </AvGroup>
            </Col>
        );
    }

    saveHandler(e, item) {
        if (GeneralUtils.isNullOrEmpty(item.name)) {
            return toast.warn("Please fill the name field!");
        } else {
            if (GeneralUtils.checkPrivilege("post_product/webmenu")) {
                this.webMenuService.updateWebMenuDisplay(item).then(response => {
                    this.uploadDocument(response.id);
                    this.refresh();
                });
            }
        }


        e.stopPropagation();
    }

    editHandler = (e, item) => {
        this.setState({
            webMenuId: item.id,
        })

        e.stopPropagation();
    }

    renderMenuSortingEdit(itemSub) {
        if (this.state.webMenuId == null) {
            return <Button color="outline-primary" className="settings-page__btn--edit"
                           onClick={(e) => this.editHandler(e, itemSub)}>
                <Translate contentKey="entity.action.cancel">Edit</Translate>
            </Button>
        }

    }

    renderMenuSortingSave(itemSub) {
        return <Button color="outline-primary" className="settings-page__btn--save"
                       onClick={(e) => this.saveHandler(e, itemSub)}>
            <Translate contentKey="entity.action.cancel">Save</Translate>
        </Button>

    }

    __handleLocationChange = (e, itemSub) => {
        const selectedBssIds = e.value || [];
        itemSub.locationBssIdList = selectedBssIds.length > 0 ? selectedBssIds.join(',') : '';
    }

    __handleChange = (e, itemSub) => {
        let value = e.target.parsedValue !== undefined ? e.target.parsedValue : e.target.value;
        const scheduleFields = ['startHour', 'startMinute', 'endHour', 'endMinute'];
        if (scheduleFields.includes(e.target.name)) {
            value = value === '' || value === null ? null : parseInt(value, 10);
        }
        itemSub[e.target.name] = value;
    }


    renderCards() {
        let form = [];
        if (this.state.webMenuList != undefined && !GeneralUtils.isNullOrEmpty(this.state.webMenuList) && this.state.webMenuList.length > 0) {
            this.state.webMenuList.forEach(itemSub => {
                form.push(
                    <div key={itemSub.id} className="settings-page__web-menu-card">
                        <Card className="check" hoverable>
                            <FormSection title={itemSub.name}>
                                <Row>
                                    <Col md={12}>
                                        {this.renderName(itemSub)}
                                    </Col>
                                    <Col md={6}>
                                        {this.renderMenuSorting(itemSub)}
                                    </Col>
                                    <Col md={6}>
                                        {this.renderMenuSortingNo(itemSub)}
                                    </Col>
                                    <Col md={6}>
                                        {this.renderSubMenuSorting(itemSub)}
                                    </Col>

                                    <Col md={12}>
                                        {this.renderImage(itemSub)}
                                    </Col>
                                </Row>
                                <Row>
                                    {this.renderScheduleFields(itemSub)}
                                </Row>
                                <Row>
                                    {this.renderLocationFields(itemSub)}
                                </Row>
                                <Row>
                                    <Col md={6}>
                                        {this.renderMenuSortingSave(itemSub)}
                                    </Col>
                                </Row>
                                <div className="settings-page__web-menu-card-actions">
                                    {this.renderEditIcon(itemSub)}
                                    {this.renderAddNewIcon(itemSub)}
                                </div>

                            </FormSection>

                        </Card>
                    </div>
                )
                ;
            });
        }
        return form;
    }

    webMenuList() {
        return (
            <>
                <div className="settings-page__header">
                    <h1 className="settings-page__title">Web Menu</h1>
                </div>
                <div className="settings-page__panel settings-page__section">
                    <div className="settings-page__toolbar settings-page__toolbar--start settings-page__toolbar--wrap">
                        {GeneralUtils.checkPrivilege("post_product/webmenu") &&
                            <Button color="outline-primary" className="settings-page__btn--add settings-page__btn--wrap" onClick={() => {
                                this.addNew();
                            }}>
                                <Translate contentKey="entity.action.add">Add Menu</Translate>
                            </Button>}
                        <Button color="outline-primary" className="settings-page__btn--action settings-page__btn--wrap"
                                onClick={() => {
                                    this.restTableService.syncWebMenuToArtpos().then(response => this.setState({}));
                                }}>
                            <Translate contentKey="entity.action.add">Sync to Artpos</Translate>
                        </Button>
                    </div>
                    {this.renderItems()}
                </div>
            </>
        );
    }
    ;

    onDataSelect = (data) => {
        const jsonArray = JSON.stringify(this.state.crumbItems);
        sessionStorage.setItem("crumbItems", jsonArray);
        window.location.href = "#webMenuSave?" + data.id;
    }

    onItemClick = async (data) => {
        let crumbItems = this.state.crumbItems;
        let length = crumbItems.length;
        if (data.hasSubMenu) {
            crumbItems.push({
                label: data.name, id: data.id, order: length, command: (e) => {
                    data.order = length;
                    this.refreshCrumbItems(data)
                    this.loadInitialWebMenus(data.id);

                }
            })
            this.loadInitialWebMenus(data.id);

        }

    }

    getParentId() {
        let parentId = null;
        let crumbItems = this.state.crumbItems;
        if (crumbItems.length > 0) {
            parentId = crumbItems[crumbItems.length - 1].id;
        }
        return parentId;

    }

    addNew() {
        let parentId = this.getParentId();
        const jsonArray = JSON.stringify(this.state.crumbItems);
        sessionStorage.setItem("crumbItems", jsonArray);
        window.location.href = "#webMenuSave?" + "?" + parentId;
    }


    loadInitialWebMenus = (parentId) => {
        this.setState({
            offset: 0,
            allDataLoaded: false,
            webMenuList: [],
            loading: true
        }, () => {
            this.loadMoreWebMenus(parentId);
        });
    }

    loadMoreWebMenus = (parentId) => {
        const { offset, limit, searchBarcode, filterOption } = this.state;

        // hasImage durumu filtre seçimine göre belirleniyor
        let hasImage = null;
        if (filterOption === "hasImage") hasImage = true;
        else if (filterOption === "noImage") hasImage = false;

        this.setState({ loading: true });

        this.webMenuService.findSubMenusByParentId(parentId, offset, limit, searchBarcode, hasImage)
            .then(response => {
                if (response && response.length > 0) {
                    this.setState(prevState => ({
                        webMenuList: [...prevState.webMenuList, ...response],
                        offset: prevState.offset + limit,
                        loading: false
                    }));
                } else {
                    this.setState({ allDataLoaded: true, loading: false });
                }
            })
            .catch(() => this.setState({ loading: false }));
    };



    showDeleteConfirmDialog = (data) => {
        this.setState({
            deleteDataId: data.id,
            displayShowStatusConfirmDialog: true,
            noticeResponse: "Are you sure to delete?"
        });
    }

    delete = () => {

        if (!GeneralUtils.isNullOrEmpty(this.state.deleteDataId)) {
            this.webMenuService.delete(this.state.deleteDataId)
                .then((response) => {
                    this.setState({
                        deleteDataId: null,
                    });
                    this.refresh();
                });
        }
    }
    __handleChangeBarcode = (e) => {
        let value = e.target.parsedValue !== undefined ? e.target.parsedValue : e.target.value;
        this.setState({barcode: value});
    }

    __handleChangeSearchBarcode = (e) => {
        const value =
            e.target.parsedValue !== undefined
                ? e.target.parsedValue
                : e.target.value;

        this.setState({ searchBarcode: value });

        // eğer 2 veya daha fazla karakter girildiyse backend'den çek
        if (!GeneralUtils.isNullOrEmpty(value) && value.length > 1) {
            this.setState(
                { loading: true, offset: 0, webMenuList: [], allDataLoaded: false },
                () => {
                    const {  filterOption } = this.state;
                    let hasImage = null;
                    if (filterOption === "hasImage") hasImage = true;
                    else if (filterOption === "noImage") hasImage = false;

                    this.webMenuService
                        .findSubMenusByParentId(this.getParentId(), 0, 30, value, hasImage)
                        .then((response) => {
                            this.setState({
                                webMenuList: response || [],
                                loading: false,
                                allDataLoaded: !response || response.length < 30,
                            });
                        })
                        .catch(() => this.setState({ loading: false }));
                }
            );
        } else {
            const {  filterOption } = this.state;
            let hasImage = null;
            if (filterOption === "hasImage") hasImage = true;
            else if (filterOption === "noImage") hasImage = false;

            this.webMenuService
                .findSubMenusByParentId(this.getParentId(), 0, 30, null, hasImage)
                .then((response) => {
                    this.setState({
                        webMenuList: response || [],
                        loading: false,
                        allDataLoaded: !response || response.length < 30,
                    });
                })
                .catch(() => this.setState({ loading: false }));

        }
    };



    _handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            this.findByBarcode();
        }
    }

    searchProduct = (event) => {
        setTimeout(() => {
            this.productService.searchProductsByName(event.query).then(response => {
                this.setState({filteredProducts: response});

            });
        }, 250);
    }


    findByBarcode() {
        if (!GeneralUtils.isNullOrEmpty(this.state.barcode)) {
            this.productService.findProductByBarcode(this.state.barcode)
                .then((response) => {
                    if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                        let data = response;
                        this.webMenuService.addItemToWebMenu(this.getParentId(), data.id, -1).then((response) => {
                            if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                                this.refresh();
                            }

                        });


                    } else {
                        this.setState({
                            barcode: '', selectedProduct: null, productId: null, productList: []
                        });
                        return toast.warn("Barcode not Found!");
                    }
                });
        }
        this.setState({barcode: ''});

    }

    __handleChangeMainGroup = (e) => {
        let value = e.target.parsedValue !== undefined ? e.target.parsedValue : e.target.value;
        let webMenu = this.state.webMenu;
        webMenu[e.target.name] = value;
        this.setState({webMenu: webMenu});

        if (!GeneralUtils.isNullOrEmpty(value) && !GeneralUtils.isNullOrEmpty(this.state.mainGroupList)) {
            for (var i = 0; i < this.state.mainGroupList.length; i++) {
                if (this.state.mainGroupList[i].id == value) {
                    this.setState({productList: this.state.mainGroupList[i].products});
                }

            }
        } else {
            this.setState({productList: []});
        }
    }
    __handleChangeProduct = (e) => {
        let value = e.target.parsedValue !== undefined ? e.target.parsedValue : e.target.value;
        if (!GeneralUtils.isNullOrEmpty(value)) {
            this.webMenuService.addItemToWebMenu(this.getParentId(), value, this.state.webMenu.grpMain).then((response) => {
                if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                    this.refresh();
                }
            });
        }

    }

    handleFilterChange = (e) => {
        const value = e.value;
        this.setState({
            filterOption: value,
            offset: 0,
            webMenuList: [],
            searchBarcode:null,
            allDataLoaded: false
        }, () => {
            this.loadMoreWebMenus(this.getParentId());
        });
    };

    removeDocument(id, type) {
        if (!GeneralUtils.isNullOrEmpty(id)) {
            this.webMenuService.removeDocument(id, type).then(response => {
                if (this.uploadRefs[id]) {
                    this.uploadRefs[id].clear();
                }
                this.setState(prevState => ({
                    webMenuList: prevState.webMenuList.map(item =>
                        item.id === id
                            ? { ...item, webImagePath: null, fileName: null }
                            : item
                    )
                }));
            });
        }
    }

    uploadDocument(id) {
        const ref = this.uploadRefs[id];
        if (ref && ref.files && ref.files.length > 0) {
            let formData = new FormData();
            formData.append("file", ref.files[0]);

            this.webMenuService.uploadDocument(id, formData, WEB_MENU_SMALL_IMAGE).then(() => {
                // FileUpload'ı temizle
                if (ref) ref.clear();

                // 500 ms gecikmeden sonra listeyi yenile
                setTimeout(() => {
                    const parentId = this.getParentId();
                    if (GeneralUtils.isNullOrEmpty(parentId)) {
                        this.webMenuService.findParents().then(response =>
                            this.setState({ webMenuList: response })
                        );
                    } else {
                        this.webMenuService.findSubMenusByParentId(parentId).then(response =>
                            this.setState({ webMenuList: response })
                        );
                    }
                }, 500); // ⏱️ yarım saniye bekle
            });
        }
    }




}

